import { Stringable } from '@chr/online-shared-ui-localizations/TranslationProvider/types';
import { VisibilityBooking } from '../apis/dtos';
import { Step } from 'react-joyride';

export const getStepsForGuidedTour = (
  translate: (resourceKey: string, replacements?: Stringable[] | undefined) => string,
  isMobileScreen: boolean,
  booking: VisibilityBooking
): Step[] => {
  const steps = [
    {
      title: translate('Booking Overview'),
      target: '.booking-details',
      content: translate(
        "This card displays key booking details, including IDs, mode, status, and risk level. It helps you quickly understand the booking's current state and journey."
      ),
      disableScrolling: !isMobileScreen,
      disableBeacon: true,
      placement: 'top',
    },
    {
      title: translate('Key Parties & Terms'),
      target: '.quick-reference',
      content: translate(
        'Find essential information about the shipper, consignee, notify party, and INCO terms here. This helps ensure smooth handling of the booking.'
      ),
      disableScrolling: !isMobileScreen,
      disableBeacon: true,
    },
    {
      title: translate('Navigate with Tabs'),
      target: '.bookingdetail-tabs-menu',
      content: translate(
        'These tabs organise booking information into groups. Easily access detailed data by switching between them. The tracking tab will be selected by default.'
      ),
      disableScrolling: !isMobileScreen,
      disableBeacon: true,
    },
    {
      title: translate('Transportation Plan'),
      target: '.transportation-plan',
      content: translate(
        'Find important details on related shipments here. With the right permissions, click a shipment number to access its detailed view.'
      ),
      disableScrolling: false,
      disableBeacon: true,
    },
    {
      title: translate('Route Map'),
      target: '.tracking-map',
      content: translate(
        "View the shipment's journey on this map, including stops and route. It updates dynamically as the cargo progresses."
      ),
      disableScrolling: !isMobileScreen,
      disableBeacon: true,
    },
    {
      title: translate('Documents Tab'),
      target: '.bookingsdetail-tabs',
      content: translate(
        'Easily download, email, and upload all related documents here. Manage your booking documents with just a few clicks.'
      ),
      disableScrolling: !isMobileScreen,
      disableBeacon: true,
    },
  ] as Step[];

  if (booking.hasShipmentFetchError) {
    steps.splice(3, 1);
    steps[3].disableScrolling = false;
  }

  return steps;
};
